<template>
	<QModal
		id="modal-settings"
		ref="modal"
		v-model="modalOpenValue"
		:title="translateKey('common_set_custom_settings')"
		:no-close-on-backdrop="true"
		:auto-close-on-ok="false"
		:ok-disabled="isTestingConnection"
		:cancel-title="translateKey('label_cancel')"
		ok-variant="secondary"
		:ok-title="translateKey('label_save')"
		@hidden="onCloseSettings()"
		@click-cancel="resetCustomSettings()"
		@click-ok="sendCustomSettings()"
	>
		<template #modal-title>
			{{ translateKey('common_set_custom_settings') }}
		</template>
		<div class="d-flex w-100 flex-column row-gap-4">
			<div class="row align-items-center">
				<label
					class="col-3 text-left"
					for="backendUrl"
				>
					{{ translateKey('common_backend_url') }}
				</label>
				<QFormFieldInput
					id="backendUrl"
					v-model="cloudBackendUrl"
					class="col-9"
					name="backendUrl"
					:placeholder="translateKey('common_backend_url')"
					:hidden-validation="true"
					autocomplete="off"
					rules="required"
				/>
			</div>
			<div
				v-if="connectionTestFailed"
				class="row"
			>
				<div class="col-9 offset-3 text-danger">
					{{ translateKey('common_backend_url_test_failed') }}
				</div>
			</div>
			<div class="row">
				<div class="col-9 offset-3">
					<QButton
						variant="outline-secondary"
						size="sm"
						@click="resetToDefaultUrl()"
					>
						{{ translateKey('label_reset') }}
					</QButton>
				</div>
			</div>
		</div>
	</QModal>
</template>
<script lang="ts" src="./q-settings.ts"></script>
<style>
#modal-settings .q-form-field {
	margin-bottom: var(--spacer-0);
}
</style>
